import { useRouter } from 'next/navigation';
import { logout as logoutAction } from '@/app/server/actions';
import { Button } from '../Button';
import { StatusModal } from '../StatusModal';
type Props = {
  className?: string;
  onCloseLogout: () => void;
  open: boolean;
};
export const LogoutModal = ({
  onCloseLogout,
  open
}: Props) => {
  const router = useRouter();
  const logout = async () => {
    await logoutAction();
    router.refresh();
    onCloseLogout();
  };
  return <StatusModal buttonsChildren={<>
          <Button fullWIdth onClick={logout}>
            Так, я хочу вийти на цьому пристрої
          </Button>
          <Button bordered fullWIdth onClick={onCloseLogout}>
            Ні, я залишаюсь
          </Button>
        </>} description='Увага! Здійснюючи вихід, ви втратите всі незбережені дані без можливості їх відтворення. Бажаєте продовжити?' logoStatus='sad' onOpenChange={onCloseLogout} open={open} data-sentry-element="StatusModal" data-sentry-component="LogoutModal" data-sentry-source-file="LogoutModal.tsx"></StatusModal>;
};